module.exports = __webpack_public_path__ + "static/img/M-700-ITALIAN-WALNUT.9824f2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/M-700-ITALIAN-WALNUT.png
// module id = DUHD
// module chunks = 0